import { fetchCategories, fetchAreas, fetchQuestions } from './services'

const getDefaultState = () => {
  return {
    categories: null,
    areas: {},
    questions: {},
    currentCategory: null,
    currentArea: null
  }
}

const state = getDefaultState()

const getters = {
  getCategories: (state) => {
    return state.categories ? state.categories : null
  },
  getAreas: (state) => {
    return state.areas ? state.areas : null
  },
  getQuestions: (state) => {
    return state.questions ? state.questions : null
  },
  getCurrentCategory: (state) => {
    return state.currentCategory ? state.currentCategory : null
  },
  getCurrentArea: (state) => {
    return state.currentArea ? state.currentArea : null
  }
}

const actions = {
  async loadCategoriesAction  ({ commit, rootState }) {
    const userData = rootState.auth.userData
    if(userData) {
      const res = await fetchCategories(userData.system)
      if (res && res.categories) {
        return commit('categoriesReceived', res.categories)
      }
    }
  },
  async loadAreasAction  ({ commit, rootState }, category) {
    const userData = rootState.auth.userData
    const res = await fetchAreas(userData.system, category)
    if (res) {
      commit('setCurrentCategory', category)
      return commit('areasReceived', res)
    }
  },
  async loadQuestionsAction  ({ commit, rootState }, area) {
    const userData = rootState.auth.userData
    const category = state.currentCategory
    const res = await fetchQuestions(userData.system, category, area)
    if (res) {
      commit('setCurrentArea', area)
      return commit('questionsReceived', res)
    }
  },
  setCurrentCategoryAction ({ commit }, category) {
    commit('setCurrentCategory', category)
  },
  setCurrentAreaAction ({ commit }, area) {
    commit('setCurrentArea', area)
  },
  resetStateAction ({ commit }) {
    commit('resetState')
  }
}

const mutations = {
  categoriesReceived (state, categories) {
    state.categories = categories
  },
  setCurrentCategory (state, category) {
    state.currentCategory = category
  },
  areasReceived (state, areas) {
    state.areas = areas
  },
  setCurrentArea (state, area) {
    state.currentArea = area
  },
  questionsReceived (state, questions) {
    state.questions = questions
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  getters,
  namespaced: true,
  state,
  actions,
  mutations
}
